import {Accordion} from "react-bootstrap";
import React from "react";

export default function AccordionDocFirmato({
                                                titolo,
                                                children,
                                                defaultKey = '0',
                                                colore = 'black'
                                            }) {

    return (
        <Accordion className={'mb-1'} defaultActiveKey={defaultKey}>
            <Accordion.Item eventKey="0">
                <Accordion.Header
                    className={`rfi-accordion-header-doc-firmati rfi-accordion-header-doc-firmati--${colore}`}
                >
                    {titolo}
                </Accordion.Header>
                <Accordion.Body>
                    {
                        children
                    }
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}